import angular from 'angular';
import { VideoThumbnailWrapper } from '../../../modules/patient/components/video-thumbnail/video-thumbnail-wrapper';
import { RenderWithWrapper } from '../../../global/global.react';
class VideoWidgetBridgeController {
    constructor($element, $scope) {
        this.$element = $element;
        this.$scope = $scope;
        this.render = () => {
            RenderWithWrapper(VideoThumbnailWrapper, { url: this.url, title: this.videoTitle, videoSource: this.videoSource }, this.$element[0], this.$scope);
        };
    }
    $onInit() {
        this.render();
    }
}
const videoWidgetBridge = {
    template: '<div></div>',
    bindings: {
        url: '<',
        videoTitle: '<',
        videoSource: '<',
    },
    controller: VideoWidgetBridgeController,
};
export default angular
    .module('doxy.common.components.videoWidgetBridge', [])
    .component('videoWidgetBridge', videoWidgetBridge).name;
